<template>
  <v-dialog v-model="enableModal" max-width="1000">
    <v-card>
      <v-card-title>Отправлено {{ total }} писем для добавления пост-индекса. Успешно добавлено на {{ successCount }} писем</v-card-title>
      <v-card-text>
        <v-data-table :headers="tableHeaders" :items="records" item-key="Uid" class="elevation-1"
                      hide-default-footer disable-pagination>
          <template v-slot:items="props">
            <tr>
              <td>{{ props.item.Uid }}</td>
              <td>{{ props.item.Receiver }}</td>
              <td>{{ props.item.Region.Name }}</td>
              <td>{{ props.item.Area.Name }}</td>
              <td>{{ props.item.Address }}</td>
              <td v-if="props.item.postIndex">{{ props.item.PostIndex.PostCode }}</td>
              <td v-else></td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-card-actions class="modal-footer">
    <v-spacer></v-spacer>
      <div class="col-12 d-block d-md-flex align-center flex-md-row flex-column">
        <v-col cols="12" md="12" class="d-flex align-center justify-center justify-md-end">
          <v-btn color="success"
                 style="margin-right: 10px"
                 @click="createPrintPackageClicked">
            Новая печать
          </v-btn>
          <v-btn color="primary" @click="closeModal">Закрыть</v-btn>
        </v-col>
      </div>

  </v-card-actions>
  </v-dialog>
</template>

<style scoped>
.modal-footer {
  position: sticky;
  bottom: 0;
  background-color: white;
  z-index: 2;
}
</style>

<script>
export default {
  data() {
    return {
      enableModal: false,
      total: 0,
      records: [],
      successCount: 0,
      allowCreatePrintPackage: false,

      tableHeaders: [
        { text: 'Идентификатор', value: 'Uid' },
        { text: 'Получатель', value: 'Receiver' },
        { text: 'Область', value: 'Region.Name' },
        { text: 'Район', value: 'Area.Name' },
        { text: 'Адрес', value: 'Address' },
        { text: 'Пост индекс', value: 'PostIndex.PostCode' }
      ]
    };
  },
  methods: {
    createPrintPackageClicked() {
      if(this.records){
        this.mailUids = this.records.map(record => record.Uid);
        this.$emit('send-records', this.mailUids);
      }
    },
    set(response) {
      this.total = response.DataTable.Total;
      this.records = response.DataTable.Records;
      this.successCount = response.SuccssCount;

      this.enableModal = true;
    },
    closeModal() {
      this.$emit('close-modal');
    }
  }
};
</script>
